/*!
   Copyright 2019 Ron Buckton

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
/* @internal */ export const D1 = new Intl.NumberFormat("en-US", { style: "decimal", minimumIntegerDigits: 1, maximumFractionDigits: 0, useGrouping: false }).format;
/* @internal */ export const D2 = new Intl.NumberFormat("en-US", { style: "decimal", minimumIntegerDigits: 2, maximumFractionDigits: 0, useGrouping: false }).format;
/* @internal */ export const D3 = new Intl.NumberFormat("en-US", { style: "decimal", minimumIntegerDigits: 3, maximumFractionDigits: 0, useGrouping: false }).format;
/* @internal */ export const D4 = new Intl.NumberFormat("en-US", { style: "decimal", minimumIntegerDigits: 4, maximumFractionDigits: 0, useGrouping: false }).format;
/* @internal */ export const D5 = new Intl.NumberFormat("en-US", { style: "decimal", minimumIntegerDigits: 5, maximumFractionDigits: 0, useGrouping: false }).format;
/* @internal */ export const D6 = new Intl.NumberFormat("en-US", { style: "decimal", minimumIntegerDigits: 6, maximumFractionDigits: 0, useGrouping: false }).format;